import React from 'react';
import {
  List,
  Datagrid,
  Create,
  SimpleForm,
  SelectInput,
  ReferenceInput,
  EditButton,
  DeleteButton,
  TextInput,
  TextField,
  NumberInput,
  translate as t,
} from 'admin-on-rest';

import Edit from '../components/Edit';
import TranslatableInput from '../components/inputs/TranslatableInput';

export const PositionList = (props) => (
  <List {...props}>
    <Datagrid>
      <TextField source="identifier" />
      <EditButton {...props} basePath="/positions" />
      <DeleteButton {...props} basePath="/positions" />
    </Datagrid>
  </List>
);

const PositionTitle = t(({ record, translate }) => (
  <span>{record ? translate('edit.title', { title: record.identifier }) : ''}</span>
));

export const PositionEdit = (props) => (
  <Edit title={<PositionTitle />} {...props}>
    <SimpleForm>
      <TextField source="identifier" />
      <TranslatableInput source="name" />
      <NumberInput source="weight" />
      <ReferenceInput reference="roles" source="role" allowEmpty>
        <SelectInput optionText="name" optionValue="name" />
      </ReferenceInput>
      <ReferenceInput reference="positions" filter={{ identifier: { $ne: props.match.params.id } }} source="parent" allowEmpty>
        <SelectInput optionText="identifier" optionValue="identifier" />
      </ReferenceInput>
    </SimpleForm>
  </Edit>
);

export const PositionCreate = (props) => (
  <Create {...props}>
    <SimpleForm redirect="list">
      <TextInput source="identifier" />
      <TranslatableInput source="name" />
      <NumberInput source="weight" />
      <ReferenceInput reference="roles" source="role" allowEmpty>
        <SelectInput optionText="name" optionValue="name" />
      </ReferenceInput>
      <ReferenceInput reference="positions" source="parent" allowEmpty>
        <SelectInput optionText="identifier" optionValue="identifier" />
      </ReferenceInput>
    </SimpleForm>
  </Create>
);
